import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {
  ReviewsCss,
  Title,
  ReviewsGrid,
  ReviewCard,
  NavigationButton,
} from "./styles";
import { useRef, useEffect, useState } from "react";

const reviews = [
  {
    name: "Maria Silva",
    rating: 5,
    service: "Troca de Tela",
    comment:
      "Excelente atendimento! Trocaram a tela do meu celular em tempo recorde e com ótimo preço.",
    date: "15/03/2024",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=faces",
  },
  {
    name: "João Santos",
    rating: 5,
    service: "Manutenção em Geral",
    comment:
      "Profissionais muito competentes. Resolveram um problema que outras assistências não conseguiram.",
    date: "28/02/2024",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces",
  },
  {
    name: "Ana Oliveira",
    rating: 5,
    service: "Troca de Bateria",
    comment: "Atendimento rápido e eficiente. Meu celular está como novo!",
    date: "10/01/2024",
    image:
      "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=faces",
  },
  {
    name: "Pedro Costa",
    rating: 5,
    service: "Recuperação de Dados",
    comment: "Salvaram todos os meus dados importantes! Serviço impecável.",
    date: "05/12/2023",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=faces",
  },
  {
    name: "Carla Mendes",
    rating: 5,
    service: "Troca de Conector",
    comment: "Preço justo e serviço de qualidade. Recomendo!",
    date: "20/11/2023",
    image:
      "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=150&h=150&fit=crop&crop=faces",
  },
  {
    name: "Lucas Ferreira",
    rating: 5,
    service: "Manutenção em Geral",
    comment: "Melhor assistência técnica da região. Atendimento nota 10!",
    date: "15/10/2023",
    image:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=faces",
  },
  {
    name: "Juliana Lima",
    rating: 5,
    service: "Troca de Tela",
    comment: "Serviço rápido e profissional. Fiquei muito satisfeita!",
    date: "30/09/2023",
    image:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=150&h=150&fit=crop&crop=faces",
  },
  {
    name: "Rafael Souza",
    rating: 5,
    service: "Recuperação de Dados",
    comment:
      "Conseguiram recuperar fotos importantes que eu tinha perdido. Excelente trabalho!",
    date: "25/08/2023",
    image:
      "https://images.unsplash.com/photo-1506795660198-e95c77602129?w=150&h=150&fit=crop&crop=faces",
  },
];

const Reviews = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isScrolling, setIsScrolling] = useState(false);

  const scroll = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const scrollAmount = 424; // 400px (card width) + 24px (gap)
      const currentScroll = scrollContainerRef.current.scrollLeft;
      const targetScroll =
        direction === "left"
          ? currentScroll - scrollAmount
          : currentScroll + scrollAmount;

      setIsScrolling(true);
      scrollContainerRef.current.scrollTo({
        left: targetScroll,
        behavior: "smooth",
      });

      setTimeout(() => {
        setIsScrolling(false);
      }, 600);
    }
  };

  useEffect(() => {
    let scrollInterval: NodeJS.Timeout;
    const container = scrollContainerRef.current;

    const startAutoScroll = () => {
      if (!isScrolling && container) {
        scrollInterval = setInterval(() => {
          if (container) {
            const maxScroll = container.scrollWidth - container.clientWidth;
            const nextPosition = container.scrollLeft + 1;

            if (nextPosition >= maxScroll) {
              container.scrollTo({
                left: 0,
                behavior: "auto",
              });
            } else {
              container.scrollTo({
                left: nextPosition,
                behavior: "auto",
              });
            }
          }
        }, 20);
      }
    };

    if (container) {
      startAutoScroll();
    }

    return () => {
      if (scrollInterval) {
        clearInterval(scrollInterval);
      }
    };
  }, [isScrolling]);

  return (
    <ReviewsCss id="reviews">
      <Title>
        <h2>Satisfação Garantida</h2>
        <p>Veja o que nossos clientes dizem sobre nossos serviços</p>
      </Title>

      <NavigationButton
        onClick={() => scroll("left")}
        style={{ left: "2rem" }}
        aria-label="Anterior"
      >
        <FaChevronLeft />
      </NavigationButton>

      <ReviewsGrid ref={scrollContainerRef}>
        {[...reviews, ...reviews].map((review, index) => (
          <ReviewCard key={index}>
            <div className="header">
              <img
                src={review.image}
                alt={review.name}
                className="profile-image"
              />
              <div className="profile-info">
                <h3>{review.name}</h3>
                <div className="rating">
                  {[...Array(review.rating)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
              </div>
            </div>
            <span className="service">{review.service}</span>
            <p className="comment">{review.comment}</p>
            <span className="date">{review.date}</span>
          </ReviewCard>
        ))}
      </ReviewsGrid>

      <NavigationButton
        onClick={() => scroll("right")}
        style={{ right: "2rem" }}
        aria-label="Próximo"
      >
        <FaChevronRight />
      </NavigationButton>
    </ReviewsCss>
  );
};

export default Reviews;
